<template>
  <div class="accoutReport">
    <div class="serch-wrap">
      <el-form
        label-position="left"
        :inline="true"
        :model="accountReportForm"
        class="demo-form-inline"
      >
        <!-- 查询项：/类型/推送时间/供货时间/售后确认时间/核算确认时间
      /付款/扣款时间/主订单号/子订单号/锐锢编码/状态/OMS单据状态/结算状态 -->
        <div>
          <el-form-item label="类型" label-width="40px">
            <el-select
              size="mini"
              clearable
              v-model="accountReportForm.order_type"
              multiple
              collapse-tags
              placeholder="请选择类型"
            >
              <el-option
                v-for="item in filterType.order_type"
                :label="item.val"
                :value="item.key"
                :key="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推送时间" label-width="60px">
            <el-row type="flex">
              <el-col>
                <el-date-picker
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="开始日期"
                  v-model="accountReportForm.push_time_start"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
              <el-col style="width: 15px"><span class="line">-</span></el-col>
              <el-col>
                <el-date-picker
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="结束日期"
                  v-model="accountReportForm.push_time_end"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="锐锢编码" label-width="60px">
            <el-input
              v-model="accountReportForm.sku_code"
              placeholder="锐锢编码"
            ></el-input>
          </el-form-item>
          <el-form-item label="OMS单据状态" label-width="90px">
            <el-select
              clearable
              v-model="accountReportForm.order_status"
              multiple
              collapse-tags
              size="mini"
              placeholder="请选择单据状态"
            >
              <el-option
                v-for="item in filterType.order_status"
                :label="item.val"
                :value="item.key"
                :key="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div class="drop-down-wrap">
            <transition name="el-fade-in-linear">
              <el-button
                v-if="!dropStatus"
                type="text"
                icon="iconfont icon-xiangxiashuangjiantou"
                style="
                  background: #fff;
                  border: none;
                  color: #666;
                  font-size: 24px;
                  padding: 0;
                "
                @click="dropHandler"
              ></el-button>
              <el-button
                v-if="dropStatus"
                type="text"
                icon="iconfont icon-xiangshangshuangjiantou"
                style="
                  background: #fff;
                  border: none;
                  color: #666;
                  font-size: 24px;
                  padding: 0;
                "
                @click="dropHandler"
              ></el-button>
            </transition>
          </div>
        </div>
        <el-collapse-transition>
          <div v-show="dropStatus">
            <div style="padding-bottom: 5px">
              <el-form-item label="供货/售后确认时间" label-width="120px">
                <el-row type="flex">
                  <el-col>
                    <el-date-picker
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      placeholder="开始日期"
                      v-model="accountReportForm.supply_time_start"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                  <el-col><span class="line">-</span></el-col>
                  <el-col>
                    <el-date-picker
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      placeholder="结束日期"
                      v-model="accountReportForm.supply_time_end"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="核算确认时间" label-width="90px">
                <el-row type="flex">
                  <el-col>
                    <el-date-picker
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      placeholder="开始日期"
                      v-model="accountReportForm.real_settle_date_start"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                  <el-col><span class="line">-</span></el-col>
                  <el-col>
                    <el-date-picker
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      placeholder="结束日期"
                      v-model="accountReportForm.real_settle_date_end"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="结算状态" label-width="60px">
                <el-select
                  clearable
                  v-model="accountReportForm.payment_bill_status"
                  multiple
                  collapse-tags
                  size="mini"
                  placeholder="请选择结算状态"
                >
                  <el-option
                    v-for="item in filterType.payment_bill_status"
                    :label="item.val"
                    :value="item.key"
                    :key="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="付款/扣款时间" label-width="90px">
                <el-row type="flex">
                  <el-col>
                    <el-date-picker
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      placeholder="开始日期"
                      v-model="accountReportForm.paid_on_start"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                  <el-col><span class="line">-</span></el-col>
                  <el-col>
                    <el-date-picker
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetime"
                      placeholder="结束日期"
                      v-model="accountReportForm.paid_on_end"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="主订单号" label-width="60px">
                <el-input
                  v-model="accountReportForm.main_number"
                  placeholder="主订单号"
                ></el-input>
              </el-form-item>
              <el-form-item label="子订单号" label-width="60px">
                <el-input
                  v-model="accountReportForm.order_number"
                  placeholder="子订单号"
                ></el-input>
              </el-form-item>
              <el-form-item label="主单状态" label-width="60px">
                <el-select
                  clearable
                  v-model="accountReportForm.ap_order_status"
                  multiple
                  collapse-tags
                  size="mini"
                  placeholder="请选择状态"
                >
                  <el-option
                    v-for="item in filterType.ap_order_status"
                    :label="item.val"
                    :value="item.key"
                    :key="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="子单状态" label-width="60px">
                <el-select
                  clearable
                  v-model="accountReportForm.ap_order_detail_status"
                  multiple
                  collapse-tags
                  size="mini"
                  placeholder="请选择状态"
                >
                  <el-option
                    v-for="item in filterType.ap_order_detail_status"
                    :label="item.val"
                    :value="item.key"
                    :key="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-collapse-transition>
        <el-form-item>
          <el-button type="primary" size="small" @click="searchBillList"
            >查询</el-button
          >
          <el-button type="primary" size="small" @click="exportOrder"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="content-wrap">
      <div class="tableTitle">
        <div
          class="tab"
          :class="{ active: reportActive === 1 }"
          @click="changeTab(1)"
        >
          订单统计
        </div>
        <div
          class="tab"
          :class="{ active: reportActive === 2 }"
          @click="changeTab(2)"
        >
          商品统计
        </div>
        <div
          class="tab"
          :class="{ active: reportActive === 3 }"
          @click="changeTab(3)"
        >
          金额统计
        </div>
      </div>
      <order-count-table
        class="orderCountTable"
        v-loading="showTable"
        :data="orderCountTableData"
        v-if="reportActive === 1"
      ></order-count-table>
      <goods-count-table
        class="goodsCountTable"
        v-loading="showTable"
        :data="goodsCountTableData"
        v-if="reportActive === 2"
      ></goods-count-table>
      <amount-goods-table
        class="orderCountTable"
        v-loading="showTable"
        :data="amountGoodsTableData"
        v-if="reportActive === 3"
      ></amount-goods-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  exportAccountData,
  getAccountFilter,
  getAccountlist,
} from "@/models/reportModel";
import goodsCountTable from "@/components/report/GoodsCountTable.vue";
import orderCountTable from "@/components/report/OrderCountTable.vue";
import AmountGoodsTable from "@/components/report/AmountGoodsTable.vue";
export default {
  components: { goodsCountTable, orderCountTable, AmountGoodsTable },
  data() {
    return {
      dropStatus: false,
      value: "",
      filterType: {
        order_type: [],
        ap_order_status: [],
        order_status: [],
        payment_bill_status: [],
        ap_order_detail_status: [],
      },
      accountReportForm: {
        start_created_at: "",
        end_created_at: "",
        start_recon_at: "",
        end_recon_at: "",
        order_type: [], // 类型
        ap_order_status: [], // 状态
        order_status: [], // 单据状态
        payment_bill_status: [], // 结算状态
        ap_order_detail_status: ["1"], // 子单状态
        push_time_start: "", // 推送开始时间
        push_time_end: "", // 推送结束时间
        supply_time_start: "", // 供货/售后确认时间 开始时间
        supply_time_end: "", // 供货/售后确认时间 结束时间
        real_settle_date_start: "", // 核算确认 开始时间
        real_settle_date_end: "", // 核算确认 结束时间
        paid_on_start: "", // 付款/扣款时间 开始时间
        paid_on_end: "", // 付款/扣款时间 结束时间
        main_number: "", // 主单号
        order_number: "", // 子单号
        sku_code: "", // 锐锢编码
      },
      reportActive: 1,
      billType: 1, // 1=订单,2=商品,3=金额
      page: 1,
      pagesize: 10,
      totalCount: 0,
      goodsCountTableData: [],
      orderCountTableData: [],
      amountGoodsTableData: [],
      showTable: true,
    };
  },
  mounted() {
    this.getBillList();
  },
  methods: {
    dropHandler() {
      this.dropStatus = !this.dropStatus;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getBillList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getBillList();
    },
    searchBillList() {
      this.page = 1;
      this.getBillList();
    },
    getBillList() {
      this.showTable = true;
      let params = {
        tab_type: this.billType,
        page: this.page,
        pagesize: this.pagesize,
      };
      let obj = Object.assign({}, this.accountReportForm);
      let str = obj.payment_bill_status.toString();
      let arr = str.split(",");
      obj.payment_bill_status = arr;
      Object.assign(params, obj);
      let isType = (type) => (target) =>
        `[object ${type}]` === Object.prototype.toString.call(target);
      let isArray = isType("Array");

      if (params.ap_order_detail_status) {
        if (!isArray(params.ap_order_detail_status)) {
          params.ap_order_detail_status = [...params.ap_order_detail_status];
        }
      }
      getAccountlist(params).then((res) => {
        if (res.code === 200) {
          let data = res.data;
          this.totalCount = Number(data.count) || 0;
          console.log(res, "对账报表");
          if (this.billType === 1) {
            // 订单
            data.list.forEach((item) => {
              if (item.hasOwnProperty("order_type")) {
                if (item.order_type === "2") {
                  // 退货数量金额 为负
                  if (item.hasOwnProperty("order_quantity")) {
                    if (item.order_quantity) {
                      item.order_quantity = Number(item.order_quantity) * -1;
                    }
                  }
                  if (item.hasOwnProperty("order_amount")) {
                    if (item.order_amount) {
                      item.order_amount = Number(item.order_amount) * -1;
                    }
                  }
                }
              }
            });
            this.orderCountTableData = data.list;
          } else if (this.billType === 2) {
            // 商品
            data.list.forEach((item) => {
              if (item.hasOwnProperty("order_type")) {
                if (item.order_type === "2") {
                  // 退货数量金额 为负
                  if (item.hasOwnProperty("sum_order_quantity")) {
                    if (item.sum_order_quantity) {
                      item.sum_order_quantity =
                        Number(item.sum_order_quantity) * -1;
                    }
                  }
                  if (item.hasOwnProperty("sum_order_amount")) {
                    if (item.sum_order_amount) {
                      item.sum_order_amount =
                        Number(item.sum_order_amount) * -1;
                    }
                  }
                }
              }
            });
            this.goodsCountTableData = data.list;
          } else if (this.billType === 3) {
            // 金额
            data.list.forEach((item) => {
              // 售后确认金额 为负
              if (item.hasOwnProperty("sum_ap_amount")) {
                item.sum_ap_amount = Number(item.sum_ap_amount) * -1;
              }
            });
            this.amountGoodsTableData = data.list;
          }
          this.showTable = false;
        }
      });
    },
    changeTab(index) {
      this.reportActive = index;
      this.billType = index;
      this.page = 1;
      this.pagesize = 10;
      this.getBillList();
    },
    async exportOrder() {
      let params = {
        tab_type: this.billType,
      };
      let newParams = {}
      // 推送开始时间
      // if(this.accountReportForm.push_time_start){
      //   params.push_time_start = this.accountReportForm.push_time_start
      // }
      // // 推送结束时间
      // if(this.accountReportForm.push_time_end){
      //   params.push_time_end = this.accountReportForm.push_time_end
      // }
      // 这些多选 需要传字符串过去 数据不行
      // 单据状态
      if (this.accountReportForm.order_status.length !== 0) {
        params.order_status = this.accountReportForm.order_status.join(",");
      }
      // 子单状态
      if (this.accountReportForm.order_status.length !== 0) {
        params.ap_order_detail_status =
          this.accountReportForm.ap_order_detail_status.join(",");
      }
      // 主单状态
      if (this.accountReportForm.ap_order_status.length !== 0) {
        params.ap_order_status =
          this.accountReportForm.ap_order_status.join(",");
      }
      // 结算状态
      if (this.accountReportForm.payment_bill_status.length !== 0) {
        params.payment_bill_status =
          this.accountReportForm.payment_bill_status.join(",");
      }
      Object.assign(newParams, this.accountReportForm, params);
      // console.log(newParams)
      await exportAccountData(newParams);
    },
  },
  created() {
    getAccountFilter({}).then((res) => {
      if (res.code === 200) {
        let data = res.data;
        this.filterType = data;
      }
    });
  },
};
</script>
<style lang="scss">
.accoutReport {
  padding-left: 10px;
  .el-form {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
  }
  .tableTitle {
    display: flex;
    .tab {
      cursor: pointer;
      height: 30px;
      width: 80px;
      margin-right: 1px;
      margin-top: 5px;
      text-align: center;
      font-size: 14px;
      line-height: 30px;
      border-radius: 8px 8px 0px 0px;
      color: white;
      background-color: rgb(115, 129, 140);
    }
    .tab.active,
    .tab:hover {
      background-color: rgb(164, 180, 193);
    }
  }
}
</style>
<style lang="scss" scoped>
.line {
  display: inline-block;
  margin: 0 5px;
}
.serch-wrap {
  position: relative;
}
.drop-down-wrap {
  position: absolute;
  right: 20px;
  top: 5px;
  // float: right;
  // display: inline-block;
}
// .accoutReport{
//   position: relative;
// }
// .serch-wrap{
//   position: fixed;
//   z-index: 10;
//   top: 80px;
//   left: 190px;
//   background: #fff;
//   width: calc(100% - 212px);
//   padding: 10px;
// }
// .content-wrap{
//   position: relative;
//   margin-top: 170px;
// }
</style>



// WEBPACK FOOTER //
// src/pages/report/accountReport.vue